import { useEffect, useRef, useState } from 'react'
import CountChart from './CountChart'
import {
  Carousel,
  DASHBOARD_CHART_COLOR,
  filterOperatorValues,
  SORT_KEYS,
  SvgReload,
  Tabs,
} from '@ui-kit'
import {
  addToaster,
  AgentType,
  BarClickType,
  CurrentSubcountType,
  DashboardServiceType,
  DataType,
  DataTypeStore,
  EmbeddedDashboardResponse,
  EntityDataByEntityFilterPayload,
  EntityLookupSearchCriteria,
  exportEntityDataByEntityIdLayoutIdApiForFilter,
  ExportRefType,
  FilterOptionType,
  getAllCaseDataApi,
  getAllEntitiesAgentAction,
  getAllServices,
  getEmbeddedDashboardData,
  getEntityDataByEntityIdLayoutIdApiForFilter,
  getInteractiveDashboardData,
  getLayoutByName,
  getUrgencyIndexFlags,
  hideLoader,
  InteractiveTileDataType,
  LayoutResponseType,
  queueListingType,
  showLoader,
  TableFilterLookupObjectBody,
  TableFilterObjectBody,
  TabsDataType,
  TabsFlagType,
  TileFilterRefType,
  TilesSummaryResponse,
  ToasterType,
  ToasterTypeValues,
  UserWiseSummaryResponse,
} from '@app-store'
import HighchartsReact from 'highcharts-react-official'
import { SeriesOptionsType } from 'highcharts'
import { STRINGS } from '../../utils/strings'
import {
  RootState,
  useAppDispatch,
  useAppSelector,
} from '../../utils/agent.store'
import { v4 as uuid } from 'uuid'
import {
  CARD_TITLE,
  COMM_TEMPLATE,
  componentNames,
  DASHBOARD,
  ENTITY_NAME,
  GRAPH_STATUS,
  HTTP_STATUS_CONSTANTS,
  INITIAL_SELECTED_TILES,
  INTAKE_QUEUE,
  INTAKE_STATUS,
  NAMESPACES,
  REPORTS,
  STATUS_ID_NOT_NULL,
  TASK_STATUS,
  TASK_STATUS_FILTER_MAP,
  TILE_BASE_CONFIG,
} from '../../utils/constants'
import { InteractiveTile } from './InteractiveTile'
import DynamicQueues from '../queue-configuration/DynamicQueues'
import { EntityLayout } from '../../types/layout.types'
import {
  formatFilterConfig,
  transformLayoutToCols,
} from '../../utils/listing.utils'
import {
  buildUiDataMappings,
  buildUserWiseSeries,
  checkTileData,
  downloadCSV,
  fetchEntityDataByName,
  getFilterBasedOnUser,
  getFormattedStatus,
  getIntakeEntityName,
  getSafeCount,
  getUrgencyIndexObject,
  normalizeIntakeChannelCounts,
  handleProgramFieldName,
  handleStatusFade,
  handleStatusHighlight,
  normalizeBooleanOperator,
  parseErrorMessage,
  transformByService,
} from '../../utils/helperFunctions'
import { ExportPayloadType } from '../../types/correspondenceLogs.types'
import moment from 'moment'
import { assignUnassignForDashBoard } from '../../apis/entityData.api'
import { AxiosResponse, isAxiosError } from 'axios'
import { QUEUE_STRINGS } from '../../utils/queueIntake.types'
import { DYNAMIC_QUEUE_CONSTANTS } from '../../constants/dynamicQueue'
import { uniqueId } from 'lodash'
import AppliedFilters from './AppliedFilters'
import { FieldValues } from 'react-hook-form'
const InteractiveDashboard = () => {
  const originalTabs = [
    {
      label: DASHBOARD.DOCUMENT,
      name: DASHBOARD.AE_PC_KEY,
      key: DASHBOARD.AE_PC_KEY,
      index: 0,
      component: <></>,
    },
    {
      label: ENTITY_NAME.CASE,
      name: ENTITY_NAME.CASE_LOWER,
      key: ENTITY_NAME.CASE_LOWER,
      index: 1,
      component: <></>,
    },
    {
      label: DASHBOARD.INTAKE,
      name: DYNAMIC_QUEUE_CONSTANTS.INTAKE_LOWERCASE,
      key: DYNAMIC_QUEUE_CONSTANTS.INTAKE_LOWERCASE,
      index: 2,
      component: <></>,
    },
    {
      label: DASHBOARD.MY_TASK,
      name: DYNAMIC_QUEUE_CONSTANTS.MY_TASK_LOWERCASE,
      key: DYNAMIC_QUEUE_CONSTANTS.MY_TASK_LOWERCASE,
      index: 3,
      component: <></>,
    },
  ]
  const originalIntakeTabs = [
    {
      label: INTAKE_QUEUE.FAX,
      name: INTAKE_QUEUE.FAX,
      key: COMM_TEMPLATE.FAX_LOWECASE,
      index: 0,
      component: <></>,
    },
    {
      label: INTAKE_QUEUE.WEB,
      name: INTAKE_QUEUE.WEB,
      key: REPORTS.WEB_KEY,
      index: 1,
      component: <></>,
    },
    {
      label: INTAKE_QUEUE.MAIL,
      name: INTAKE_QUEUE.MAIL,
      key: INTAKE_QUEUE.MAIL,
      index: 2,
      component: <></>,
    },
  ]
  const [intakeTabs, setIntakeTabs] = useState<
    {
      label: string
      component: React.ReactNode
      index: number
      name: string
    }[]
  >()
  const intakeChannelNamesRef = useRef<string[]>(
    originalIntakeTabs.map((tab) => tab.name)
  )
  const [tabs, setTabs] = useState<TabsDataType[]>([])
  const dispatch = useAppDispatch()
  const authUser = useAppSelector((state: RootState) => state?.authUser)
  const isDemoDashboardChanges =
    (
      authUser?.site_settings?.find(
        (v) => v?.key === STRINGS.DEMO_DASHBOARD_CHANGES
      )?.value as string
    )?.toLowerCase() === 'true'
  const removeUnreadableDocuments =
    (
      authUser?.site_settings?.find(
        (v) => v?.key === STRINGS.REMOVE_UNREADABLE_DOCUMENTS
      )?.value as string
    )?.toLowerCase() === 'true'
  const documentEntity = useAppSelector(
    (state: RootState) =>
      state?.entity?.entitiesByName[ENTITY_NAME.AE_PC_DOCUMENT]
  )
  const myTaskEntity = useAppSelector(
    (state: RootState) => state?.entity?.entitiesByName[ENTITY_NAME.MY_TASKS]
  )
  const faxIntakeEntity = useAppSelector(
    (state: RootState) =>
      state?.entity?.entitiesByName[QUEUE_STRINGS.COMMUNICATION_LOWERCASE]
  )
  const webIntakeEntity = useAppSelector(
    (state: RootState) =>
      state?.entity?.entitiesByName[QUEUE_STRINGS.HCP_PORTAL_ENTITY_LOWERCASE]
  )
  const selectedClientProgram = useAppSelector(
    (state: RootState) => state?.clientPrograms?.selectedClientPrograms
  )
  const selectedTenantName = useAppSelector(
    (state: RootState) =>
      state?.authUser?.selectedClientTenant?.name_of_organization
  )
  const queueConfigData = useAppSelector(
    (state: RootState) => state?.queueCreation?.children
  )
  const enabledQueues = queueConfigData.filter(
    (item: queueListingType) => item?.enabled
  )
  const commonPayload = {
    program_id: selectedClientProgram?.program_id ?? 0,
    user_id: null,
  }
  const assignedChartRef = useRef<HighchartsReact.RefObject>(null)
  const unassignedChartRef = useRef<HighchartsReact.RefObject>(null)
  const tileFilter = useRef<TileFilterRefType>({
    relatedEntities: {},
    filters: [],
  })
  const lastCallRef_2 = useRef<string>('')
  const queueLayoutRef = useRef<EntityLayout | LayoutResponseType | null>(null)
  const exportRef = useRef<ExportRefType<DataTypeStore>>({
    relatedEntities: {},
    filters: [],
    tableHeader: [],
    select: [],
  })
  const currentDashboardDetails = useRef<{
    label: string
    entity_name: string
    user_dashboard_type: string
    tiles_dashboard_type: string
    queue_id?: number
    intake?: string
  }>()
  const currentCases = useRef<CurrentSubcountType>({
    cases: {},
    cardName: '',
    serviceWiseData: null,
  })
  const allServices = useRef<DashboardServiceType[]>([])
  const selectedService = useRef<DashboardServiceType | null>(null)
  const chart = assignedChartRef.current?.chart
  const unassignedChart = unassignedChartRef.current?.chart
  const [selectedFilters, setSelectedFilters] = useState<FilterOptionType[]>([])
  const [activePoint, setActivePoint] = useState<{
    category: string
    status: string
  } | null>(null)
  const [selectedTile, setSelectedTile] = useState({
    name: '',
    subCountName: '',
  })
  const [currentTime, setCurrentTime] = useState<string>('')
  const [currentTab, setCurrentTab] = useState<{
    label: string
    component: React.ReactNode
    index: number
  }>()
  const [currentIntakeTab, setCurrentIntakeTab] = useState<{
    label: string
    component: React.ReactNode
    index: number
    name: string
  }>()
  const [refetchQueueData, setRefetchQueueData] = useState<number>(0)
  const [hasTileData, setHasTileData] = useState<boolean>(false)
  const [tileConfig, setTileConfig] = useState<InteractiveTileDataType[]>([])
  const [unAssignedChartCategories, setUnAssignedChartCategories] = useState<
    string[]
  >([])
  const [serviceIds, setServiceIds] = useState<string[]>([])
  const [unAssignedChartSeries, setUnAssignedChartSeries] = useState<
    Highcharts.SeriesOptionsType[]
  >([])

  const [assignedChartCategories, setAssignedChartCategories] = useState<
    string[]
  >([])
  const [assignedChartSeries, setAssignedChartSeries] = useState<
    Highcharts.SeriesOptionsType[]
  >([])
  const [queueLayout, setQueueLayout] = useState<EntityLayout | null>(null)

  const getQueueId = () => {
    if (currentDashboardDetails.current?.label === DASHBOARD.DOCUMENT) {
      return enabledQueues
        .filter(
          (item: queueListingType) => item?.name === DASHBOARD.DOCUMENT
        )[0]
        ?.id?.toString()
    } else if (
      currentDashboardDetails.current?.label === DASHBOARD.INTAKE &&
      currentIntakeTab?.name === INTAKE_QUEUE.WEB
    ) {
      return enabledQueues
        .filter((item: queueListingType) => item?.name === INTAKE_QUEUE.WEB)[0]
        ?.id?.toString()
    } else if (
      currentDashboardDetails.current?.label === DASHBOARD.INTAKE &&
      currentIntakeTab?.name === INTAKE_QUEUE.FAX
    ) {
      return enabledQueues
        .filter((item: queueListingType) => item?.name === INTAKE_QUEUE.FAX)[0]
        ?.id?.toString()
    } else if (
      currentDashboardDetails.current?.label === DASHBOARD.INTAKE &&
      currentIntakeTab?.name === INTAKE_QUEUE.MAIL
    ) {
      return enabledQueues
        .filter((item: queueListingType) => item?.name === INTAKE_QUEUE.MAIL)[0]
        ?.id?.toString()
    } else {
      return undefined
    }
  }

  const resetHighlight = (
    chart: Highcharts.Chart | undefined,
    resetFilter = true
  ) => {
    if (!chart) return
    if (resetFilter) {
      tileFilter.current.filters = []
      tileFilter.current.relatedEntities = {}
    }
    setActivePoint(null)

    chart.series.forEach((series) => {
      series.setState('')
      series.update(
        {
          opacity: 1,
          enableMouseTracking: true,
          dataLabels: {
            enabled: true,
          },
        } as SeriesOptionsType,
        false
      )
    })

    chart.redraw()
  }

  const handleTabChange = (label: string, index: number) => {
    setSelectedFilters([])
    setCurrentTab(tabs?.[index])
    if (label === ENTITY_NAME.CASE) {
      currentDashboardDetails.current = {
        label: ENTITY_NAME.CASE,
        entity_name: ENTITY_NAME.CASE,
        user_dashboard_type: DASHBOARD.CASE_USER_WISE,
        tiles_dashboard_type: DASHBOARD.CASE_TILES_SUMMARY,
      }
    } else if (label === DASHBOARD.DOCUMENT) {
      currentDashboardDetails.current = {
        label: DASHBOARD.DOCUMENT,
        entity_name: ENTITY_NAME.AE_PC_DOCUMENT,
        user_dashboard_type: DASHBOARD.AE_PC_USER_WISE,
        tiles_dashboard_type: DASHBOARD.AE_PC_TILES_SUMMARY,
      }
    } else if (label === DASHBOARD.MY_TASK) {
      currentDashboardDetails.current = {
        label: DASHBOARD.MY_TASK,
        entity_name: ENTITY_NAME.MY_TASKS,
        user_dashboard_type: DASHBOARD.CASE_USER_WISE,
        tiles_dashboard_type: DASHBOARD.TASK_TILES_SUMMARY,
      }
    } else {
      currentDashboardDetails.current = {
        label: DASHBOARD.INTAKE,
        entity_name: getIntakeEntityName(intakeTabs?.[0]?.name ?? ''),
        user_dashboard_type: DASHBOARD.INTAKE_USER_WISE,
        tiles_dashboard_type: DASHBOARD.INTAKE_TILES_SUMMARY,
        intake: intakeTabs?.[0]?.name,
      }
      setCurrentIntakeTab(intakeTabs?.[0])
      setSelectedTile({
        ...selectedTile,
        subCountName: intakeTabs?.[0]?.name ?? '',
      })
    }
    queueLayoutRef.current = null
    setQueueLayout(null)
    resetHighlight(chart)
    resetHighlight(unassignedChart)

    fetchDashBoardData(
      `${selectedTenantName}-${selectedClientProgram?.program_id}-${documentEntity?.id}`,
      false
    )
  }
  const handleIntakeTabChange = async (label: string, index: number) => {
    try {
      dispatch(showLoader())
      handleAppliedFilters(label.split(' ')[0], 'sub_count_name')
      setCurrentIntakeTab(intakeTabs?.[index])
      currentDashboardDetails.current = {
        label: DASHBOARD.INTAKE,
        entity_name: getIntakeEntityName(label.split(' ')[0]),
        user_dashboard_type: DASHBOARD.INTAKE_USER_WISE,
        tiles_dashboard_type: DASHBOARD.INTAKE_TILES_SUMMARY,
        intake: label.split(' ')[0],
      }
      setSelectedTile({
        ...selectedTile,
        subCountName: label.split(' ')[0],
      })
      queueLayoutRef.current = null
      setQueueLayout(null)
      resetHighlight(chart)
      resetHighlight(unassignedChart)

      await handleUserWiseData()
      await fetchLayout()
      handleGraphHighlight(currentCases.current.cardName)
    } catch (error) {
      console.log(error)
    } finally {
      dispatch(hideLoader())
    }
  }

  const onExportOption = async () => {
    try {
      dispatch(showLoader())
      const payload: ExportPayloadType = {
        entity_name:
          currentDashboardDetails.current?.entity_name.toLowerCase() ?? '',
        select: exportRef.current.select,
        related_entities: exportRef.current.relatedEntities,
        ui_data_mappings: buildUiDataMappings(exportRef.current.tableHeader),
        filters: exportRef.current.filters,
        exclude_fields: ['record_id', 'entity_type', 'category'],
      }

      const { data } = await exportEntityDataByEntityIdLayoutIdApiForFilter(
        payload
      )

      const fileName = 'data.csv'
      downloadCSV(data, fileName)
      dispatch(
        addToaster({
          id: uniqueId(),
          message: NAMESPACES.EXPORT_SUCCESSFUL,
          type: 'success',
        })
      )
    } catch (error: unknown) {
      let message = NAMESPACES.EXPORT_ERROR
      let type: ToasterTypeValues = ToasterType.ERROR

      if (isAxiosError(error)) {
        const backendMessage = error.response?.data?.message
        const statusCode = error.response?.status

        if (
          statusCode === HTTP_STATUS_CONSTANTS.SERVER_ERROR ||
          statusCode === HTTP_STATUS_CONSTANTS.GATEWAY_TIMEOUT ||
          !statusCode
        ) {
          message = NAMESPACES.EXPORT_RECORD_LIMIT_EXCEEDED
          type = ToasterType.WARNING
        } else if (
          statusCode === HTTP_STATUS_CONSTANTS.CONFLICT &&
          backendMessage
        ) {
          const parsed = parseErrorMessage(backendMessage)

          if (parsed.type === NAMESPACES.WARN) {
            message = parsed.message
            type = ToasterType.WARNING
          }
        }
      } else {
        message = NAMESPACES.EXPORT_RECORD_LIMIT_EXCEEDED
        type = ToasterType.WARNING
      }
      dispatch(
        addToaster({
          id: uniqueId(),
          message,
          type,
        })
      )
      console.log(error)
    } finally {
      dispatch(hideLoader())
    }
  }

  const handleGraphHighlight = (status: string) => {
    if (currentDashboardDetails.current?.label !== DASHBOARD.MY_TASK) {
      if (CARD_TITLE.includes(status)) {
        if (status === DASHBOARD.TOTAL_CASES_EXCLUDING_MI) {
          handleStatusFade(DASHBOARD.PAUSED_MI, chart)
          handleStatusFade(DASHBOARD.PAUSED_MI, unassignedChart)
        } else {
          handleStatusHighlight(status, chart)
          if (status !== DASHBOARD.UNASSIGNED) {
            handleStatusHighlight(status, unassignedChart)
          } else {
            resetHighlight(unassignedChart, false)
          }
        }
      } else {
        resetHighlight(chart, false)
        resetHighlight(unassignedChart, false)
      }
      setActivePoint(null)
    }
  }

  const handleBarClick = async ({ userId, category, status }: BarClickType) => {
    try {
      dispatch(showLoader())
      handleAppliedFilters(
        category ? `${category} - ${status}` : null,
        'bar_name'
      )
      if (!category) {
        tileFilter.current.filters = []
        tileFilter.current.relatedEntities = {
          services: tileFilter.current.relatedEntities?.['services'],
          urgency_index_status: getUrgencyIndexObject(
            '',
            getFormattedStatus(currentCases.current.cardName)
          ),
        }
        setRefetchQueueData((prev) => prev + 1)
        return
      }
      if (userId) {
        tileFilter.current.filters = getFilterBasedOnUser(
          currentDashboardDetails.current?.label ?? '',
          userId.toString()
        )
      } else {
        tileFilter.current.filters = getFilterBasedOnUser(
          currentDashboardDetails.current?.label ?? '',
          null
        )
      }
      if (status) {
        tileFilter.current.relatedEntities = {
          services: tileFilter.current.relatedEntities?.['services'],
          urgency_index_status: getUrgencyIndexObject(
            status,
            getFormattedStatus(currentCases.current.cardName)
          ),
        }
      }
      setRefetchQueueData((prev) => prev + 1)
    } catch (err) {
      const errorMessage = NAMESPACES.SOMETHING_WENT_WRONG
      dispatch(
        addToaster({
          id: uuid(),
          message: errorMessage,
          type: 'error',
        })
      )
    } finally {
      dispatch(hideLoader())
    }
  }

  const onSubCountClick = async (type: string) => {
    const status = currentCases.current.cardName
    const dashboardLabel = currentDashboardDetails.current?.label
    selectedService.current =
      allServices.current.find(
        (item: DashboardServiceType) => item.abbreviation === type
      ) ?? null

    const service = selectedService.current
    if (dashboardLabel === DASHBOARD.INTAKE) {
      currentDashboardDetails.current = {
        label: DASHBOARD.INTAKE,
        entity_name: getIntakeEntityName(currentIntakeTab?.name ?? ''),
        user_dashboard_type: DASHBOARD.INTAKE_USER_WISE,
        tiles_dashboard_type: DASHBOARD.INTAKE_TILES_SUMMARY,
        intake: service?.service_name,
      }
      const selectedTab = intakeTabs?.find(
        (tab) => tab.name === service?.service_name
      )
      if (type === '' || type === currentIntakeTab?.name) {
        currentDashboardDetails.current = {
          ...currentDashboardDetails.current,
          intake: type,
        }
        resetHighlight(chart)
        resetHighlight(unassignedChart)
        await handleUserWiseData()
        handleGraphHighlight(currentCases.current.cardName)
        handleAppliedFilters(
          selectedTab?.name?.split(' ')[0] ?? '',
          'sub_count_name'
        )
      } else if (service && selectedTab) {
        handleIntakeTabChange(selectedTab.name, selectedTab.index)
      }
      return
    }
    handleAppliedFilters(type, 'sub_count_name')
    const formattedStatus = getFormattedStatus(status)
    await handleUserWiseData(service)
    handleStatusCardClick(status, {}, true)
    handleGraphHighlight(status)

    if (dashboardLabel === ENTITY_NAME.CASE) {
      tileFilter.current.relatedEntities = {
        services: {
          select: ['service_name'],
          filters: [
            {
              criteria: [
                {
                  field_name: 'service_name',
                  values: [service?.service_name ?? ''],
                  operation: 'LIKE',
                },
              ],
            },
          ],
        },
        urgency_index_status: getUrgencyIndexObject(formattedStatus, ''),
      }
    } else if (dashboardLabel === DASHBOARD.MY_TASK) {
      tileFilter.current.relatedEntities = {}
    } else {
      tileFilter.current.filters = [
        {
          direction: 'ASC',
          field_name: 'status',
          operation: 'LIKE',
          values: [status],
        },
        {
          direction: 'ASC',
          field_name: 'channel',
          operation: 'LIKE',
          values: [type],
        },
      ]
    }
    setRefetchQueueData((prev) => prev + 1)
  }

  const getTileTotal = (tileName: string) =>
    tileConfig?.find((tile) => tile.tileName === tileName)?.total ?? 0

  const getIntakeChannelNames = () =>
    intakeTabs?.map((tab) => tab.name) ?? intakeChannelNamesRef.current

  const toIntakeChannelCounts = (
    value?: number | string | Record<string, number> | null
  ) => normalizeIntakeChannelCounts(value, getIntakeChannelNames())

  const onStatusCardClick = async (
    status: string,
    total: string | number | Record<string, number>
  ) => {
    handleAppliedFilters(status, 'tile_name')
    const dashboardLabel = currentDashboardDetails.current?.label

    if (!status) {
      if (dashboardLabel === ENTITY_NAME.CASE) {
        const tileName = TILE_BASE_CONFIG.total_case_including_mi.tileName

        setSelectedTile({ name: tileName, subCountName: '' })
        await handleStatusCardClick(tileName, getTileTotal(tileName))
        return
      }
      if (dashboardLabel === DASHBOARD.MY_TASK) {
        const tileName = TILE_BASE_CONFIG.all_cases.tileName

        setSelectedTile({ name: tileName, subCountName: '' })
        await handleStatusCardClick(
          tileName,
          getTileTotal(TILE_BASE_CONFIG.total_task_including_all.tileName)
        )
        return
      }

      if (dashboardLabel === DASHBOARD.DOCUMENT) {
        const tileName = TILE_BASE_CONFIG.total_document.tileName

        setSelectedTile({ name: tileName, subCountName: '' })
        await handleStatusCardClick(tileName, getTileTotal(tileName))
        return
      }

      const tileName = TILE_BASE_CONFIG.total_intake.tileName
      const totalData = getTileTotal(tileName) as Record<string, number>

      setSelectedTile((prev) => ({ ...prev, name: tileName }))
      await handleStatusCardClick(tileName, totalData)
      return
    }

    setSelectedTile((prev) => ({
      name: status,
      subCountName:
        dashboardLabel === DASHBOARD.INTAKE ? prev.subCountName : '',
    }))

    await handleStatusCardClick(status, total)
  }

  const handleStatusCardClick = async (
    status: string,
    totalCases: string | number | Record<string, number>,
    fromSubCount = false
  ) => {
    if (!fromSubCount) {
      if (selectedService.current !== null) {
        selectedService.current = null
        await handleUserWiseData()
      }

      currentCases.current = {
        cases:
          currentDashboardDetails.current?.label === DASHBOARD.INTAKE
            ? toIntakeChannelCounts(totalCases)
            : totalCases ?? '',
        cardName: status,
        serviceWiseData: currentCases.current.serviceWiseData,
      }
      setTileConfig((prev) =>
        prev.map((tile) =>
          tile.message === DASHBOARD.ALL_CASES
            ? {
                ...tile,
                total: currentCases.current.cases ?? '0',
              }
            : tile
        )
      )
    }
    handleGraphHighlight(status)
    if (
      (INTAKE_STATUS.includes(status) || status === DASHBOARD.UNASSIGNED) &&
      currentDashboardDetails.current?.label !== DASHBOARD.MY_TASK
    ) {
      tileFilter.current.relatedEntities = {
        ...(status !== DASHBOARD.UNASSIGNED
          ? {
              urgency_index_status: getUrgencyIndexObject(status, ''),
            }
          : {}),
      }
      tileFilter.current.filters = [
        ...(status === DASHBOARD.UNASSIGNED
          ? getFilterBasedOnUser(
              currentDashboardDetails.current?.label ?? '',
              null
            )
          : []),
      ]
    } else if (currentDashboardDetails.current?.label !== DASHBOARD.MY_TASK) {
      tileFilter.current.filters = []
      tileFilter.current.relatedEntities = {}
    }
    setRefetchQueueData((prev) => prev + 1)
  }
  const updateUserWiseChart = (apiData: UserWiseSummaryResponse) => {
    let summary
    if (currentDashboardDetails.current?.label === ENTITY_NAME.CASE) {
      summary = (apiData as UserWiseSummaryResponse)?.user_wise_summary_case
    } else if (currentDashboardDetails.current?.label === DASHBOARD.DOCUMENT) {
      summary = (apiData as UserWiseSummaryResponse)?.user_wise_summary_ae_pc
    } else {
      summary = (apiData as UserWiseSummaryResponse)?.user_wise_summary
    }

    const unassigned = summary?.unassigned

    // ---------- Unassigned ----------
    setUnAssignedChartCategories([DASHBOARD.UNASSIGNED])

    setUnAssignedChartSeries([
      {
        type: 'bar',
        name: DASHBOARD.OVERDUE,
        data: [unassigned?.overdue ?? 0],
        color: '#E57373',
      },
      {
        type: 'bar',
        name: DASHBOARD.AT_RISK,
        data: [unassigned?.at_risk ?? 0],
        color: '#F4D06F',
      },
      {
        type: 'bar',
        name: DASHBOARD.ON_TRACK,
        data: [unassigned?.on_track ?? 0],
        color: '#81C784',
      },
      ...(currentDashboardDetails.current?.label === ENTITY_NAME.CASE
        ? [
            {
              type: 'bar' as const,
              name: DASHBOARD.PAUSED_MI,
              data: [unassigned?.paused ?? 0],
              color: '#99CBF9',
            },
          ]
        : []),
    ])

    // ---------- Assigned Users ----------
    const assignedUsers = Object.entries(summary ?? {})
      .filter(([key]) => key !== DASHBOARD.UNASSIGNED_LOWERCASE)
      .map(([name, data]) => {
        const total =
          (data.at_risk ?? 0) +
          (data.overdue ?? 0) +
          (data.on_track ?? 0) +
          (data.paused ?? 0)

        return {
          name,
          at_risk: data.at_risk ?? 0,
          overdue: data.overdue ?? 0,
          on_track: data.on_track ?? 0,
          paused: data.paused ?? 0,
          user_id: data.user_id,
          total,
        }
      })
      .sort((a, b) => b.total - a.total)

    setAssignedChartCategories(assignedUsers.map((u) => u.name))
    if (currentDashboardDetails.current?.label === ENTITY_NAME.CASE) {
      setAssignedChartSeries([
        buildUserWiseSeries(
          assignedUsers,
          'overdue',
          DASHBOARD_CHART_COLOR.OVERDUE_COLOR
        ),
        buildUserWiseSeries(
          assignedUsers,
          'at_risk',
          DASHBOARD_CHART_COLOR.AT_RISK_COLOR
        ),
        buildUserWiseSeries(
          assignedUsers,
          'on_track',
          DASHBOARD_CHART_COLOR.ON_TRACK_COLOR
        ),
        buildUserWiseSeries(
          assignedUsers,
          'paused',
          DASHBOARD_CHART_COLOR.PAUSED_MI_COLOR
        ),
      ])
    } else {
      setAssignedChartSeries([
        buildUserWiseSeries(
          assignedUsers,
          'overdue',
          DASHBOARD_CHART_COLOR.OVERDUE_COLOR
        ),
        buildUserWiseSeries(
          assignedUsers,
          'at_risk',
          DASHBOARD_CHART_COLOR.AT_RISK_COLOR
        ),
        buildUserWiseSeries(
          assignedUsers,
          'on_track',
          DASHBOARD_CHART_COLOR.ON_TRACK_COLOR
        ),
      ])
    }
  }
  const handleUserWiseData = async (
    selectedService?: DashboardServiceType | null
  ) => {
    try {
      if (currentDashboardDetails?.current?.label !== DASHBOARD.MY_TASK) {
        dispatch(showLoader())
        const dashboardType =
          currentDashboardDetails.current?.user_dashboard_type ?? ''
        const isIntake =
          currentDashboardDetails.current?.label === DASHBOARD.INTAKE
        const intakeValue = currentDashboardDetails.current?.intake
        const userWisePayload = {
          ...commonPayload,
          dashboard_type: dashboardType,
          ...(isIntake
            ? {
                source_type: intakeValue ? intakeValue : null,
              }
            : {
                service_id: selectedService?.id ?? null,
              }),
        }
        const userWiseResponse = await getInteractiveDashboardData(
          userWisePayload
        )
        updateUserWiseChart(userWiseResponse?.data)
      }
    } catch (error) {
      console.log(error)
    } finally {
      dispatch(hideLoader())
    }
  }
  const updateTiles = (apiData: TilesSummaryResponse) => {
    let summary: Record<string, Record<string, number>> | undefined
    if (currentDashboardDetails.current?.label === ENTITY_NAME.CASE) {
      summary = (apiData as TilesSummaryResponse)?.tiles_summary_case
      currentCases.current = {
        cases: summary?.total_including_paused ?? '',
        cardName: TILE_BASE_CONFIG.total_case_including_mi.tileName,
        serviceWiseData: transformByService(apiData.tiles_summary_case ?? {}),
      }
      setSelectedTile({
        name: TILE_BASE_CONFIG.total_case_including_mi.tileName,
        subCountName: '',
      })
    } else if (currentDashboardDetails.current?.label === DASHBOARD.MY_TASK) {
      summary = (apiData as TilesSummaryResponse)?.tiles_summary_task
      currentCases.current = {
        cases: summary?.total ?? '',
        cardName: TILE_BASE_CONFIG.total_case_including_mi.tileName,
        serviceWiseData: transformByService(apiData.tiles_summary_task ?? {}),
      }
      setSelectedTile({
        name: TILE_BASE_CONFIG.all_cases.tileName,
        subCountName: '',
      })
    } else if (currentDashboardDetails.current?.label === DASHBOARD.DOCUMENT) {
      summary = (apiData as TilesSummaryResponse)?.tiles_summary_ae_pc
      currentCases.current = {
        cases: '',
        cardName: TILE_BASE_CONFIG.total_document.tileName,
        serviceWiseData: null,
      }
      setSelectedTile({
        name: TILE_BASE_CONFIG.total_document.tileName,
        subCountName: '',
      })
    } else {
      summary = (apiData as TilesSummaryResponse)?.tiles_summary
      const intakeTotals = toIntakeChannelCounts(summary?.total)
      currentCases.current = {
        cases: intakeTotals,
        cardName: TILE_BASE_CONFIG.total_intake.tileName,
        serviceWiseData: transformByService(apiData.tiles_summary ?? {}),
      }
      setSelectedTile({
        name: TILE_BASE_CONFIG.total_intake.tileName,
        subCountName: '',
      })
    }
    setTileConfig([
      ...(currentDashboardDetails.current?.label === DASHBOARD.INTAKE ||
      currentDashboardDetails.current?.label === DASHBOARD.DOCUMENT
        ? [
            {
              ...(currentDashboardDetails.current?.label === DASHBOARD.INTAKE
                ? TILE_BASE_CONFIG.overdue_intake
                : TILE_BASE_CONFIG.overdue_document),
              total:
                currentDashboardDetails.current?.label === DASHBOARD.INTAKE
                  ? toIntakeChannelCounts(summary?.overdue)
                  : summary?.overdue ?? '0',
            },
            {
              ...(currentDashboardDetails.current?.label === DASHBOARD.INTAKE
                ? TILE_BASE_CONFIG.at_risk_intake
                : TILE_BASE_CONFIG.at_risk_document),
              total:
                currentDashboardDetails.current?.label === DASHBOARD.INTAKE
                  ? toIntakeChannelCounts(summary?.at_risk)
                  : summary?.at_risk ?? '0',
            },
            {
              ...(currentDashboardDetails.current?.label === DASHBOARD.INTAKE
                ? TILE_BASE_CONFIG.on_track_intake
                : TILE_BASE_CONFIG.on_track_document),
              total:
                currentDashboardDetails.current?.label === DASHBOARD.INTAKE
                  ? toIntakeChannelCounts(summary?.on_track)
                  : summary?.on_track ?? '0',
            },
            {
              ...(currentDashboardDetails.current?.label === DASHBOARD.INTAKE
                ? TILE_BASE_CONFIG.total_intake
                : TILE_BASE_CONFIG.total_document),
              total:
                currentDashboardDetails.current.label === DASHBOARD.INTAKE
                  ? currentCases.current.cases
                  : String(summary?.total ?? '0'),
            },
            {
              ...(currentDashboardDetails.current?.label === DASHBOARD.INTAKE
                ? TILE_BASE_CONFIG.unassigned_intake
                : TILE_BASE_CONFIG.unassigned_document),
              total:
                currentDashboardDetails.current?.label === DASHBOARD.INTAKE
                  ? toIntakeChannelCounts(summary?.unassigned)
                  : summary?.unassigned ?? '0',
            },
            ...(currentDashboardDetails.current?.label === DASHBOARD.INTAKE
              ? [
                  {
                    ...TILE_BASE_CONFIG.all_cases,
                    total: currentCases.current.cases,
                  },
                ]
              : []),
          ]
        : []),

      ...(currentDashboardDetails.current?.label === ENTITY_NAME.CASE
        ? [
            {
              ...TILE_BASE_CONFIG.overdue_case,
              total: summary?.overdue ?? '0',
            },
            {
              ...TILE_BASE_CONFIG.at_risk_case,
              total: summary?.at_risk ?? '0',
            },
            {
              ...TILE_BASE_CONFIG.on_track_case,
              total: summary?.on_track ?? '0',
            },
            {
              ...TILE_BASE_CONFIG.total_case_including_mi,
              ...(typeof summary?.total_including_paused === 'object' &&
              summary?.total_including_paused !== null
                ? {
                    total: summary.total_including_paused ?? '0',
                  }
                : {
                    total: String(summary?.total_including_paused ?? 0),
                  }),
            },
            {
              ...TILE_BASE_CONFIG.total_case,
              ...(typeof summary?.total === 'object' && summary?.total !== null
                ? {
                    total: summary.total ?? '0',
                  }
                : {
                    total: String(summary?.total ?? 0),
                  }),
            },
            {
              ...TILE_BASE_CONFIG.paused_case,
              total: summary?.paused ?? '0',
            },
            {
              ...TILE_BASE_CONFIG.all_cases,
              total: currentCases.current.cases ?? '0',
            },
          ]
        : []),

      ...(currentDashboardDetails.current?.label === DASHBOARD.MY_TASK
        ? [
            {
              ...TILE_BASE_CONFIG.total_task_assigned,
              total: summary?.total ?? '0',
            },
            {
              ...TILE_BASE_CONFIG.tasks_due_today,
              total: summary?.tasks_due_today ?? '0',
            },
            {
              ...TILE_BASE_CONFIG.in_progress,
              total: summary?.in_progress ?? '0',
            },
            {
              ...TILE_BASE_CONFIG.tasks_completed,
              total: summary?.tasks_completed ?? '0',
            },
            {
              ...TILE_BASE_CONFIG.total_task_including_all,
              total: currentCases.current.cases ?? '0',
            },
            {
              ...TILE_BASE_CONFIG.all_cases,
              total: currentCases.current.cases ?? '0',
            },
          ]
        : []),
    ])
    const isIntakeDashboard =
      currentDashboardDetails.current?.label === DASHBOARD.INTAKE
    if ((summary && checkTileData(summary)) || isIntakeDashboard) {
      setHasTileData(true)
    } else {
      setHasTileData(false)
      throw new Error('')
    }
  }

  const handleTilesData = async () => {
    try {
      dispatch(showLoader())
      const dashboardType =
        currentDashboardDetails.current?.tiles_dashboard_type ?? ''
      const tileSummaryPayload = {
        ...commonPayload,
        dashboard_type: dashboardType,
      }
      const tilesResponse = await getInteractiveDashboardData(
        tileSummaryPayload
      )
      updateTiles(tilesResponse?.data)
    } catch (error) {
      setHasTileData(false)
      console.log(error)
    } finally {
      dispatch(hideLoader())
    }
  }
  const fetchProgramServices = async () => {
    try {
      if (
        currentDashboardDetails.current?.label === ENTITY_NAME.CASE ||
        currentDashboardDetails.current?.label === DASHBOARD.MY_TASK
      ) {
        dispatch(showLoader())
        const entity = await fetchEntityDataByName('urgency_index')
        const payload = {
          entity_id: entity?.id?.toString(),
          select: ['programs', 'entity_name', 'service_id', 'program_id'],
          filters: [
            {
              criteria: [
                {
                  field_name: 'entity_name',
                  operation: filterOperatorValues.EQUALS,
                  values: [ENTITY_NAME.CASE_LOWER],
                },
              ],
            },
            {
              criteria: [
                {
                  field_name: 'record_status',
                  operation: filterOperatorValues.EQUALS,
                  values: ['ACTIVE'],
                },
              ],
            },
            {
              criteria: [
                {
                  field_name: 'program_id',
                  operation: filterOperatorValues.EQUALS,
                  values: [selectedClientProgram?.program_id ?? 0],
                },
              ],
            },
          ],
        }
        const response = await getEntityDataByEntityIdLayoutIdApiForFilter({
          payload: payload as EntityDataByEntityFilterPayload,
          entityName: 'urgency_index',
        })
        const uniqueServicesIds = [
          ...new Set(
            response?.data?.map((item: FieldValues) => String(item.service_id))
          ),
        ]
        setServiceIds(uniqueServicesIds as unknown as string[])
      }
    } catch (err) {
      console.log(err)
    } finally {
      dispatch(hideLoader())
    }
  }
  const getTaskStatusFilterValue = (tileStatus: string): string | null => {
    return TASK_STATUS_FILTER_MAP[tileStatus] ?? null
  }
  const handleEmbeddedDashboardData = async (
    filter: TableFilterObjectBody | undefined,
    page: number,
    size: number,
    sortDirection: {
      keyName: string
      direction: SORT_KEYS
      isAsc: SORT_KEYS
      key: string
    }
  ): Promise<EmbeddedDashboardResponse | null> => {
    try {
      const normalizedFilter = normalizeBooleanOperator(filter)
      const related_entities: Record<string, { select: string[] }> = {}
      Object.entries(
        queueLayoutRef.current?.layout_data?.added_fields ?? {}
      ).forEach(([fieldName, field]) => {
        if (field?.ui_data_type === componentNames.SINGLE_LOOKUP)
          related_entities[fieldName] = {
            select: Object.keys(field.added_fields ?? {}),
          }
      })
      if (queueLayoutRef.current) {
        const tableHeader = transformLayoutToCols(
          queueLayoutRef.current as LayoutResponseType,
          queueLayoutRef.current?.entity_id,
          queueLayoutRef.current?.entity_name
        )
        exportRef.current.tableHeader = tableHeader
        exportRef.current.select = tableHeader.map((col) => col.accessor)
        tableHeader.forEach((col) => {
          col.filterData = undefined

          if (col.componentName === componentNames.LINKED) {
            col.componentName = componentNames.SINGLE_LOOKUP
            col.isLookup = true
          }
        })
        const formatFilter: {
          filter_criteria: EntityLookupSearchCriteria[]
          related_entities: TableFilterLookupObjectBody
        } =
          normalizedFilter ?? sortDirection
            ? (formatFilterConfig(
                normalizedFilter ?? {},
                tableHeader,
                'Entity',
                {
                  key: sortDirection?.key ?? '',
                  direction: sortDirection?.direction?.toUpperCase() ?? '',
                }
              ) as {
                filter_criteria: EntityLookupSearchCriteria[]
                related_entities: TableFilterLookupObjectBody
              })
            : { filter_criteria: [], related_entities: {} }
        Object.keys(formatFilter.related_entities).forEach((key) => {
          if (related_entities[key]) {
            formatFilter.related_entities[key].select =
              related_entities[key].select
          }
        })
        const overdueOrCaseCriteria = formatFilter?.filter_criteria
          ?.flatMap((fc) => fc.criteria ?? [])
          ?.filter((item) =>
            [
              'urgency_index_status.overdue_time',
              'c_case_statuses.overall_case_status',
            ].includes(item.field_name)
          )
        if (currentDashboardDetails.current?.label === ENTITY_NAME.CASE) {
          tileFilter.current.relatedEntities = {
            services: {
              select: ['service_name'],
              filters: [
                {
                  criteria: [
                    {
                      field_name: 'service_name',
                      values:
                        formatFilter.related_entities?.['services']?.[
                          'filters'
                        ]?.[0].criteria?.[0]?.values ?? [],
                      operation: 'LIKE',
                    },
                  ],
                },
              ],
            },
            urgency_index_status: {
              select: ['id', 'status'],
              filters: [
                {
                  criteria: [
                    {
                      field_name: 'status',
                      operation:
                        formatFilter.related_entities?.[
                          'urgency_index_status'
                        ]?.['filters']?.[0].criteria?.[0]?.operation ?? 'LIKE',
                      values:
                        formatFilter.related_entities?.[
                          'urgency_index_status'
                        ]?.['filters']?.[0].criteria?.[0]?.values ?? [],
                    },
                  ],
                },
              ],
            },
            c_case_statuses: {
              select: ['overall_case_status'],
              filters: [
                {
                  criteria:
                    formatFilter.related_entities?.['overall_case_status']?.[
                      'filters'
                    ]?.[0].criteria,
                },
              ],
            },
            ...tileFilter.current.relatedEntities,
          }
        } else if (
          currentDashboardDetails.current?.label === DASHBOARD.DOCUMENT
        ) {
          tileFilter.current.relatedEntities = {
            urgency_index_status: {
              select: ['id', 'overdue_time', 'status'],
              filters: [
                {
                  criteria: STATUS_ID_NOT_NULL,
                },
              ],
            },
            ...tileFilter.current.relatedEntities,
          }
        } else if (
          currentDashboardDetails.current?.label === DASHBOARD.MY_TASK
        ) {
          tileFilter.current.relatedEntities = {}
        } else {
          tileFilter.current.relatedEntities = {
            urgency_index_status: {
              select: ['id', 'status'],
              filters: [
                {
                  criteria: [
                    {
                      field_name: 'status',
                      operation:
                        formatFilter.related_entities?.[
                          'urgency_index_status'
                        ]?.['filters']?.[0].criteria?.[0]?.operation ?? 'LIKE',
                      values: formatFilter.related_entities?.[
                        'urgency_index_status'
                      ]?.['filters']?.[0].criteria?.[0]?.values ?? [
                        INTAKE_STATUS.includes(selectedTile.name)
                          ? selectedTile.name === DASHBOARD.PAUSED_MI
                            ? selectedTile.name.slice(0, -4)
                            : selectedTile.name
                          : '',
                      ],
                    },
                  ],
                },
              ],
            },
            ...(currentIntakeTab?.name === INTAKE_QUEUE.FAX ||
            currentIntakeTab?.name === INTAKE_QUEUE.MAIL
              ? {
                  category_communication_type: {
                    select: ['label'],
                    filters: [
                      {
                        criteria: [
                          {
                            field_name: 'label',
                            operation: 'LIKE',
                            values: [currentIntakeTab?.name],
                          },
                        ],
                      },
                    ],
                  },
                }
              : {}),
            ...tileFilter.current.relatedEntities,
          }
          tileFilter.current.filters =
            selectedTile.name === DASHBOARD.UNASSIGNED
              ? getFilterBasedOnUser(
                  currentDashboardDetails.current?.label ?? '',
                  null
                )
              : tileFilter.current.filters
        }
        exportRef.current.relatedEntities =
          currentDashboardDetails.current?.label === DASHBOARD.MY_TASK
            ? {}
            : {
                ...formatFilter.related_entities,
                ...(tileFilter.current.relatedEntities
                  ?.category_communication_type && {
                  category_communication_type: {
                    select:
                      tileFilter.current.relatedEntities
                        ?.category_communication_type?.select ?? [],
                    filters: [
                      ...(formatFilter.related_entities
                        ?.category_communication_type?.filters ?? []),
                      ...(tileFilter.current.relatedEntities
                        ?.category_communication_type?.filters ?? []),
                    ],
                  },
                }),
                ...(tileFilter.current.relatedEntities?.services && {
                  services: {
                    select:
                      tileFilter.current.relatedEntities?.services?.select ??
                      [],
                    filters: [
                      ...(formatFilter.related_entities?.services?.filters ??
                        []),
                      ...(tileFilter.current.relatedEntities?.services
                        ?.filters ?? []),
                    ],
                  },
                }),
                ...(tileFilter.current.relatedEntities
                  ?.urgency_index_status && {
                  urgency_index_status: {
                    select:
                      tileFilter.current.relatedEntities?.urgency_index_status
                        ?.select ?? [],
                    filters: [
                      ...(formatFilter.related_entities?.urgency_index_status
                        ?.filters ?? []),
                      ...(tileFilter.current.relatedEntities
                        ?.urgency_index_status?.filters ?? []),
                      ...(overdueOrCaseCriteria.length &&
                      currentDashboardDetails.current?.label ===
                        DASHBOARD.DOCUMENT
                        ? [
                            {
                              criteria: [
                                {
                                  field_name: 'overdue_time',
                                  operation: overdueOrCaseCriteria[0].operation,
                                  values: overdueOrCaseCriteria[0].values,
                                  direction: overdueOrCaseCriteria[0].direction,
                                },
                              ],
                            },
                          ]
                        : []),
                      {
                        criteria: STATUS_ID_NOT_NULL,
                      },
                      ...(currentCases.current.cardName ===
                      DASHBOARD.TOTAL_CASES_EXCLUDING_MI
                        ? [
                            {
                              criteria: [
                                {
                                  field_name: 'status',
                                  operation: 'NOT_EQUALS',
                                  values: ['Paused'],
                                },
                              ],
                            },
                          ]
                        : []),
                    ],
                  },
                }),
                ...(tileFilter.current.relatedEntities?.c_case_statuses && {
                  c_case_statuses: {
                    select:
                      tileFilter.current.relatedEntities?.c_case_statuses
                        ?.select ?? [],
                    filters: [
                      ...(formatFilter.related_entities?.c_case_statuses
                        ?.filters ?? []),
                      ...(tileFilter.current.relatedEntities?.c_case_statuses
                        ?.filters ?? []),
                      ...(overdueOrCaseCriteria.length &&
                      currentDashboardDetails.current?.label ===
                        ENTITY_NAME.CASE
                        ? overdueOrCaseCriteria.map((item) => ({
                            criteria: [
                              {
                                field_name: 'overall_case_status',
                                operation: item?.operation ?? 'EQUALS',
                                values: item?.values ?? [],
                                direction: item?.direction ?? 'ASC',
                              },
                            ],
                          }))
                        : []),
                    ],
                  },
                }),
              }

        const taskStatusValue =
          currentDashboardDetails.current?.label === DASHBOARD.MY_TASK
            ? getTaskStatusFilterValue(currentCases?.current?.cardName)
            : null

        const isDueTodayTile =
          currentDashboardDetails.current?.label === DASHBOARD.MY_TASK &&
          currentCases.current.cardName === DASHBOARD.DUE_TODAY

        const selectedServiceId =
          currentDashboardDetails.current?.label === DASHBOARD.MY_TASK &&
          selectedService.current?.id
            ? [String(selectedService.current.id)]
            : null

        const userId = authUser?.user?.id?.toString() ?? ''
        exportRef.current.filters =
          currentDashboardDetails.current?.label === DASHBOARD.MY_TASK
            ? [
                {
                  criteria: [
                    ...(formatFilter?.filter_criteria?.flatMap(
                      (fc) => fc.criteria ?? []
                    ) ?? []),
                    ...(isDueTodayTile
                      ? [
                          {
                            field_name: 'task_status',
                            operation: filterOperatorValues.IN,
                            values: [TASK_STATUS.PENDING, TASK_STATUS.OPEN],
                          },
                        ]
                      : taskStatusValue
                      ? [
                          {
                            field_name: 'task_status',
                            operation: 'EQUALS',
                            values: [taskStatusValue],
                          },
                        ]
                      : []),
                    ...(isDueTodayTile
                      ? [
                          {
                            field_name: 'due_date',
                            operation: 'EQUALS',
                            values: [moment().format('YYYY-MM-DD')],
                          },
                        ]
                      : []),
                    ...(selectedServiceId?.length
                      ? [
                          {
                            field_name: 'service_id',
                            operation: 'EQUALS',
                            values: selectedServiceId,
                          },
                        ]
                      : []),
                    ...[
                      {
                        field_name: 'user_id',
                        operation: 'EQUALS',
                        values: [userId],
                      },
                      {
                        field_name: 'program_id',
                        operation: 'EQUALS',
                        values: [
                          selectedClientProgram?.program_id?.toString() ?? '',
                        ],
                      },
                    ],
                  ],
                },
              ]
            : [
                {
                  criteria: [
                    ...(formatFilter?.filter_criteria?.flatMap(
                      (fc) => fc.criteria ?? []
                    ) ?? []),
                    ...(Array.isArray(tileFilter.current.filters)
                      ? tileFilter.current.filters
                      : []),
                    ...(!isDemoDashboardChanges
                      ? [
                          {
                            direction: 'ASC',
                            field_name:
                              currentDashboardDetails.current?.label ===
                              DASHBOARD.INTAKE
                                ? handleProgramFieldName(
                                    currentIntakeTab?.name ?? ''
                                  )
                                : handleProgramFieldName(''),
                            operation: 'LIKE',
                            values: [
                              selectedClientProgram?.program_id?.toString() ??
                                '',
                            ],
                          },
                        ]
                      : []),
                    ...(currentDashboardDetails.current?.label ===
                    ENTITY_NAME.CASE
                      ? [
                          {
                            field_name: 'service_id',
                            operation: filterOperatorValues.IN,
                            values: serviceIds,
                          },
                        ]
                      : []),
                    ...(removeUnreadableDocuments &&
                    currentDashboardDetails.current?.label ===
                      DASHBOARD.DOCUMENT
                      ? [
                          {
                            field_name: STRINGS.AE_PC_STATUS_FIELD,
                            operation: filterOperatorValues.NOT_IN,
                            values: [STRINGS.AE_PC_STATUS_UNREADABLE],
                          },
                        ]
                      : []),
                  ].filter(
                    (c) =>
                      c.field_name !== 'urgency_index_status.overdue_time' &&
                      c.field_name !== 'c_case_statuses.overall_case_status'
                  ),
                },
              ]
        const isMyTask =
          currentDashboardDetails.current?.label === DASHBOARD.MY_TASK
        const payload = {
          entity_id: queueLayoutRef.current?.entity_id,
          select: [
            ...tableHeader.map((col) => col.accessor),
            'programs',
            'category_communication_type',
          ],
          page: page < 0 ? 0 : page,
          size: size,
          ...(isMyTask
            ? {}
            : { related_entities: exportRef.current.relatedEntities }),
          filters: exportRef.current.filters,
          layout_id: queueLayoutRef.current?.id ?? 0,
        }
        let response: AxiosResponse
        if (currentDashboardDetails.current?.label === DASHBOARD.INTAKE) {
          response = await getEmbeddedDashboardData(
            payload,
            currentDashboardDetails.current?.entity_name
          )
          const totalData: Record<string, number> = getTileTotal(
            TILE_BASE_CONFIG.all_cases.tileName
          ) as Record<string, number>

          setIntakeTabs((prevTabs) =>
            prevTabs?.map((tab) => {
              const baseLabel = tab.label.split(' ')[0]
              const count = getSafeCount(
                currentIntakeTab?.name === tab.name
                  ? response.data.totalElements
                  : totalData?.[tab.name]
              )

              return {
                ...tab,
                label: `${baseLabel} (${count})`,
              }
            })
          )
        } else if (
          currentDashboardDetails.current?.label === ENTITY_NAME.CASE
        ) {
          response = await getAllCaseDataApi(payload)
        } else {
          response = await getEmbeddedDashboardData(
            payload,
            currentDashboardDetails.current?.entity_name ?? ''
          )
        }
        return response
      } else {
        return null
      }
    } catch (error) {
      console.log(error)
      return null
    }
  }
  const handleTabs = (data: TabsFlagType) => {
    const documentTab = data?.['ae_pc_dashboard']
    const faxTab = data?.['fax_dashboard']
    const webTab = data?.['web_dashboard']
    const caseTab = data?.['case_dashboard']
    const mailTab = data?.['mail_dashboard']
    const myTaskTab = data?.['my_task_dashboard']
    const intakeTabsToSet = []
    const tabsToSet = []
    if (isDemoDashboardChanges) {
      if (myTaskTab) tabsToSet.push(originalTabs[3])
      if (caseTab) tabsToSet.push(originalTabs[1])
      if (documentTab) tabsToSet.push(originalTabs[0])
      if (faxTab || webTab || mailTab) tabsToSet.push(originalTabs[2])
    } else {
      if (documentTab) tabsToSet.push(originalTabs[0])
      if (caseTab) tabsToSet.push(originalTabs[1])
      if (faxTab || webTab || mailTab) tabsToSet.push(originalTabs[2])
    }
    if (faxTab) {
      intakeTabsToSet.push(originalIntakeTabs[0])
    }
    if (webTab) {
      intakeTabsToSet.push(originalIntakeTabs[1])
    }
    if (mailTab) {
      intakeTabsToSet.push(originalIntakeTabs[2])
    }
    intakeChannelNamesRef.current = intakeTabsToSet.map((tab) => tab.name)
    setCurrentIntakeTab(intakeTabsToSet[0])
    setIntakeTabs(intakeTabsToSet)
    if (isDemoDashboardChanges && myTaskTab) {
      currentDashboardDetails.current = {
        label: DASHBOARD.MY_TASK,
        entity_name: ENTITY_NAME.MY_TASKS,
        user_dashboard_type: DASHBOARD.CASE_USER_WISE,
        tiles_dashboard_type: DASHBOARD.TASK_TILES_SUMMARY,
      }
    } else if (documentTab) {
      currentDashboardDetails.current = {
        label: DASHBOARD.DOCUMENT,
        entity_name: ENTITY_NAME.AE_PC_DOCUMENT,
        user_dashboard_type: DASHBOARD.AE_PC_USER_WISE,
        tiles_dashboard_type: DASHBOARD.AE_PC_TILES_SUMMARY,
      }
    } else if (caseTab) {
      currentDashboardDetails.current = {
        label: ENTITY_NAME.CASE,
        entity_name: ENTITY_NAME.CASE,
        user_dashboard_type: DASHBOARD.CASE_USER_WISE,
        tiles_dashboard_type: DASHBOARD.CASE_TILES_SUMMARY,
      }
    } else {
      currentDashboardDetails.current = {
        label: DASHBOARD.INTAKE,
        entity_name: getIntakeEntityName(currentIntakeTab?.name ?? ''),
        user_dashboard_type: DASHBOARD.INTAKE_USER_WISE,
        tiles_dashboard_type: DASHBOARD.INTAKE_TILES_SUMMARY,
        intake: intakeTabsToSet[0].name,
      }
    }
    setCurrentTab(tabsToSet?.[0])
    setTabs(tabsToSet)
  }
  const fetchDashBoardData = async (callKey2: string, initialLoad = false) => {
    try {
      dispatch(showLoader())
      const text = `Last updated at ${moment().format('hh:mmA | MMM DD, YYYY')}`
      setCurrentTime(text)
      lastCallRef_2.current = callKey2
      if (initialLoad) {
        const response = await getUrgencyIndexFlags(
          selectedClientProgram?.program_id ?? 0
        )
        handleTabs(response.data)
      } else {
        setRefetchQueueData((prev) => prev + 1)
      }
      await fetchServices()
      await handleTilesData()
      await handleUserWiseData()
      await fetchLayout()
      handleGraphHighlight(currentCases.current.cardName)
    } catch (err) {
      const errorMessage = NAMESPACES.SOMETHING_WENT_WRONG
      dispatch(
        addToaster({
          id: uuid(),
          message: errorMessage,
          type: 'error',
        })
      )
      setHasTileData(false)
    } finally {
      dispatch(hideLoader())
    }
  }
  const fetchLayout = async (): Promise<EntityLayout | null> => {
    try {
      dispatch(showLoader())
      let layout
      let entityId: string | undefined
      let layoutName: string | undefined
      if (queueLayoutRef.current) {
        return queueLayoutRef.current as EntityLayout
      }

      if (currentDashboardDetails.current?.label === DASHBOARD.INTAKE) {
        entityId = faxIntakeEntity?.id?.toString()
        layoutName = DASHBOARD.FAX_INTAKE_DASHBOARD

        if (currentDashboardDetails.current?.intake === INTAKE_QUEUE.WEB) {
          entityId = webIntakeEntity?.id?.toString()
          layoutName = DASHBOARD.WEB_INTAKE_DASHBOARD
        } else if (
          currentDashboardDetails.current?.intake === INTAKE_QUEUE.MAIL
        ) {
          entityId = faxIntakeEntity?.id?.toString()
          layoutName = DASHBOARD.MAIL_INTAKE_DASHBOARD
        }
      } else if (currentDashboardDetails.current?.label === ENTITY_NAME.CASE) {
        entityId = ENTITY_NAME.CASE_ENTITY_ID
        layoutName = DASHBOARD.CASE_DASHBOARD
      } else if (currentDashboardDetails.current?.label === DASHBOARD.MY_TASK) {
        entityId = myTaskEntity?.id?.toString()
        layoutName = DASHBOARD.TASK_DASHBOARD
      } else if (documentEntity?.id) {
        entityId = documentEntity.id.toString()
        layoutName = DASHBOARD.AE_PC_DASHBOARD
      }

      if (entityId && layoutName) {
        const response = await getLayoutByName({ entityId, layoutName })
        layout = response.data
      }
      queueLayoutRef.current = layout
      setQueueLayout(layout)

      return layout
    } catch (error) {
      console.log(error)
      return null
    } finally {
      dispatch(hideLoader())
    }
  }

  const handleAssignUnassign = async (
    agent: {
      label: string
      value: string
      id: number
      status: string
    } | null,
    rows: DataType[]
  ) => {
    try {
      dispatch(showLoader())
      let response
      const rowIds = rows?.map((row) => row.id?.toString())
      if (
        currentDashboardDetails.current?.label === ENTITY_NAME.CASE ||
        currentDashboardDetails.current?.label === DASHBOARD.INTAKE
      ) {
        response = await assignUnassignForDashBoard(
          rowIds.join(','),
          queueLayoutRef.current?.entity_id ?? 0,
          queueLayoutRef.current?.id ?? 0,
          agent?.id ?? null,
          currentDashboardDetails.current.entity_name,
          currentDashboardDetails.current?.label === DASHBOARD.INTAKE
            ? 'users_id'
            : 'user_id'
        )
        await handleTilesData()
        await handleUserWiseData()
        return response
      } else if (
        currentDashboardDetails.current?.label === DASHBOARD.DOCUMENT
      ) {
        await handleTilesData()
        await handleUserWiseData()
      }
      return response
    } catch (error) {
      console.log(error)
    } finally {
      dispatch(hideLoader())
    }
  }
  const handleReloadButtonClick = () => {
    setSelectedFilters([])
    resetHighlight(chart)
    resetHighlight(unassignedChart)
    queueLayoutRef.current = null
    setQueueLayout(null)

    fetchDashBoardData(
      `${selectedTenantName}-${selectedClientProgram?.program_id}-${documentEntity?.id}`,
      false
    )
  }

  const fetchServices = async () => {
    try {
      dispatch(showLoader())
      if (
        currentDashboardDetails.current?.label === ENTITY_NAME.CASE ||
        currentDashboardDetails.current?.label === DASHBOARD.MY_TASK
      ) {
        const response = await getAllServices()
        allServices.current = response.data
      } else {
        allServices.current = [
          {
            abbreviation: INTAKE_QUEUE.FAX,
            service_name: INTAKE_QUEUE.FAX,
            id: INTAKE_QUEUE.FAX,
          },
          {
            abbreviation: INTAKE_QUEUE.WEB,
            service_name: INTAKE_QUEUE.WEB,
            id: INTAKE_QUEUE.WEB,
          },
          {
            abbreviation: INTAKE_QUEUE.MAIL,
            service_name: INTAKE_QUEUE.MAIL,
            id: INTAKE_QUEUE.MAIL,
          },
        ]
      }
    } catch (error) {
      console.log(error)
    } finally {
      dispatch(hideLoader())
    }
  }

  const handleClearChip = async (value: FilterOptionType) => {
    if (value.key === 'tile_name') {
      await onStatusCardClick(
        '',
        tileConfig?.find((tile) => tile.message === DASHBOARD.ALL_CASES)
          ?.total ?? {}
      )
    } else if (value.key === 'sub_count_name') {
      onSubCountClick('')
      setSelectedTile({
        ...selectedTile,
        subCountName: '',
      })
    } else {
      handleBarClick({
        userId: null,
        category: null,
        status: null,
      })
      setActivePoint(null)
    }
  }
  const handleClearAll = async () => {
    await onStatusCardClick(
      '',
      tileConfig?.find((tile) => {
        return tile.message === DASHBOARD.ALL_CASES
      })?.total ?? {}
    )
    if (currentDashboardDetails.current?.label === DASHBOARD.INTAKE) {
      await onSubCountClick('')
      setSelectedTile((prev) => ({
        ...prev,
        subCountName: '',
      }))
    }
  }
  const handleAppliedFilters = (value: string | null, key: string) => {
    const isEmpty = value == null || value.length === 0

    const isInitialTile =
      key === 'tile_name' && INITIAL_SELECTED_TILES.includes(value ?? '')

    setSelectedFilters((prev) => {
      if (isInitialTile) {
        return []
      }
      let filtered: FilterOptionType[] = []
      if (key === 'sub_count_name') {
        filtered = prev.filter(
          (item) => item.key !== 'bar_name' && item.key !== 'sub_count_name'
        )
      } else if (key === 'bar_name') {
        filtered = prev.filter((item) => item.key !== 'bar_name')
      }

      if (isEmpty) return filtered

      return [...filtered, { key, value }]
    })
  }

  useEffect(() => {
    if (!assignedChartSeries) return

    if (assignedChartSeries?.length > 0) {
      handleGraphHighlight(currentCases.current.cardName)
    }
  }, [assignedChartSeries])

  useEffect(() => {
    if (
      !selectedClientProgram?.program_id ||
      !selectedTenantName ||
      !documentEntity?.id
    )
      return
    const callKey2 = `${selectedTenantName}-${selectedClientProgram?.program_id}-${documentEntity?.id}`
    queueLayoutRef.current = null
    setQueueLayout(null)
    resetHighlight(chart)
    resetHighlight(unassignedChart)
    setSelectedFilters([])

    if (lastCallRef_2.current === callKey2) return

    fetchDashBoardData(callKey2, true)
  }, [selectedTenantName, selectedClientProgram, documentEntity?.id])
  useEffect(() => {
    fetchProgramServices()
  }, [
    currentDashboardDetails?.current,
    selectedTenantName,
    selectedClientProgram,
  ])
  useEffect(() => {
    dispatch(getAllEntitiesAgentAction())
  }, [dispatch, authUser.selectedClientTenant?.id, selectedClientProgram])

  return (
    <div className="flex flex-col h-full">
      <div className="bg-tertiary-100 flex flex-col h-full">
        <div className="flex justify-between items-center bg-white sticky top-0 z-20">
          {tabs.length > 0 && hasTileData && (
            <>
              <Tabs
                key={currentTab?.label}
                tabs={tabs}
                onChange={handleTabChange}
                width="w-full"
                defaultActive={currentTab}
                inActiveFontColor="text-accent-400"
                tabsWrapperClassName="h-full flex flex-col pl-[0.5rem]"
                tabsContentClassName=" flex-1 min-h-0"
              ></Tabs>
              <div className="flex gap-2 items-center">
                <span className="text-gray-400 text-sm ml-2">
                  {currentTime}
                </span>
                <button
                  className="cursor-pointer flex p-1"
                  onClick={handleReloadButtonClick}
                >
                  <SvgReload />
                </button>
              </div>
            </>
          )}
        </div>
        {!hasTileData ? (
          <span className="font-primary leading-6 text-xs px-2 py-3 flex items-center">
            {STRINGS.DASHBOARD_TILE_VERBIAGE}
          </span>
        ) : (
          <>
            {tileConfig?.length > 0 && (
              <div className="flex">
                <Carousel
                  items={tileConfig}
                  renderItem={(data, index) => (
                    <InteractiveTile
                      key={index}
                      {...data}
                      onStatusCardClick={onStatusCardClick}
                      onSubCountClick={(type) => {
                        onSubCountClick(type)
                        setSelectedTile({
                          ...selectedTile,
                          subCountName: type,
                        })
                      }}
                      selectedTile={selectedTile.name}
                      selectedSubCount={selectedTile.subCountName}
                      serviceWiseData={currentCases.current.serviceWiseData}
                    />
                  )}
                  showScrolls={true}
                />
              </div>
            )}
            {selectedFilters.length > 0 && (
              <AppliedFilters
                selectedFilters={selectedFilters}
                handleClearChip={handleClearChip}
                handleClearAll={handleClearAll}
              />
            )}
            <div className="px-2 flex-1 min-h-0 flex flex-col h-full">
              {currentDashboardDetails.current?.label &&
                currentDashboardDetails.current?.label !==
                  DASHBOARD.MY_TASK && (
                  <CountChart
                    assigned={{
                      ref: assignedChartRef,
                      categories: assignedChartCategories,
                      series: assignedChartSeries,
                    }}
                    unassigned={{
                      ref: unassignedChartRef,
                      categories: unAssignedChartCategories,
                      series: unAssignedChartSeries,
                    }}
                    handleBarClick={handleBarClick}
                    selectedTab={currentDashboardDetails.current?.label}
                    setActivePoint={setActivePoint}
                    activePoint={activePoint}
                    highlightedStatus={
                      GRAPH_STATUS.includes(currentCases.current.cardName)
                        ? currentCases.current.cardName
                        : null
                    }
                  />
                )}
              {currentDashboardDetails.current?.label === DASHBOARD.INTAKE && (
                <div className="flex bg-white">
                  <Tabs
                    key={currentIntakeTab?.label}
                    tabs={intakeTabs ?? []}
                    onChange={handleIntakeTabChange}
                    width="w-full"
                    defaultActive={currentIntakeTab}
                    inActiveFontColor="text-accent-400"
                    tabsWrapperClassName="h-full flex flex-col pl-[0.5rem] bg-white"
                    tabsContentClassName=" flex-1 min-h-0"
                  ></Tabs>
                </div>
              )}
              {!!queueLayout && (
                <div className="flex-1 min-h-0 flex flex-col h-full w-full bg-white">
                  <DynamicQueues
                    isDashboard={true}
                    embeddedDashboardData={(
                      filter: TableFilterObjectBody | undefined,
                      page: number,
                      size: number,
                      sortDirection
                    ) =>
                      handleEmbeddedDashboardData(
                        filter,
                        page,
                        size,
                        sortDirection
                      )
                    }
                    refetchKeyFromDashboard={refetchQueueData}
                    fetchDashboardLayout={() => fetchLayout()}
                    onExportOption={() => onExportOption()}
                    dashboardListName={currentDashboardDetails.current?.label}
                    handleAssignUnassignForDashboard={(
                      agent: AgentType | null,
                      rows: DataType[]
                    ) => handleAssignUnassign(agent, rows)}
                    entityid={queueLayoutRef.current?.entity_id?.toString()}
                    layoutid={queueLayoutRef.current?.id?.toString()}
                    id={getQueueId()}
                  />
                </div>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  )
}

export default InteractiveDashboard
